'use strict';

var app = angular.module('harriApp');

app.directive('showTeamUserIndicators', ['TSUsersService', 'TeamScheduleService', 'userServices', '$compile', '$filter', '$state', 'hEmployeeSatisfactionService', function (TSUsersService, TeamScheduleService, userServices, $compile, $filter, $state, hEmployeeSatisfactionService) {
    return {
        restrict: 'A',
        scope: {
            teamUserId: "<",
            viewStatus: "<",
            date: '<'
        },
        link: function ($scope, $element, iAttrs) {
            var user;
            var isVoluntaryStandbyListEnabled = false;
            var isMinorRulesEnabled = false;
            var isLoaEnabled = false;

            var drawIcons = function () {
                var order = 0;

                if (iAttrs.showVslIndicator && isVoluntaryStandbyListEnabled && user.isVSLOptIn()) {
                    ++order;
                    Utils.addVSLOptInIndicator($element);
                }

                if (isMinorRulesEnabled && iAttrs.showMinorIndicator && user.isMinor()) {
                    if (order === 0) {
                        order = 2;
                    } else {
                        ++order;
                    }

                    Utils.addMinorIndicator($element);
                }

                if (iAttrs.showWorkVisaIndicator && user.hasWorkVisa()) {
                    ++order;
                    Utils.addWorkVisaIndicator($element);
                }

                if (iAttrs.showLactationBreakIndicator && user.hasEffectiveLactationPeriod($scope.date)) {
                    ++order;
                    Utils.addLactationBreakIndicator($element);
                }

                if (iAttrs.showLoaIndicator && isLoaEnabled && user.hasEffectiveLOA($scope.date)) {
                    ++order;
                    Utils.addLoaIndicator($element);
                }

                if (iAttrs.showManagerIndicator && user.isManager()) {
                    ++order;
                    Utils.addManagerIndicator($element);
                }

                if (iAttrs.showSharedLocationIndicator && user.isInSharedLocation($scope.date)) {
                    ++order;
                    Utils.addSharedLocationIndicator($element);
                }

                if (iAttrs.showAnonymousEmployeeIndicator && self.showAnonymousEmployee && user.isAnonymous()) {
                    ++order;
                    Utils.addAnonymousUserIndicator($element);
                }

                hEmployeeSatisfactionService.isEmployeeSatisfactionEnabled($scope.activeBrand.id)
                    .then(function (isEmployeeSatisfactionServiceEnabled) {
                        if (!isEmployeeSatisfactionServiceEnabled) return;

                        if (!$scope.showSmilesLoader) {
                            $($element).find(".member-overall-satisfaction").remove();
                            $($element).find(".member-trend-status").remove();
                        }
                    });
            };

            var init = function () {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        $scope.activeBrand = brand;

                        user = TSUsersService.users[$scope.teamUserId];
                        isMinorRulesEnabled = brand.is_minor_rules_enabled;
                        isLoaEnabled = TeamScheduleService.isLoaEnabled(brand);

                        var promises = {
                            'isVoluntaryStandbyListEnabled': userServices.isServiceEnabled(userServices.SERVICES.VOLUNTARY_STANDBY_LIST, brand.id),
                            'isAnonymisingEmployeesEnabled': userServices.isServiceEnabled(userServices.SERVICES.ANONYMISING_EMPLOYEES, brand.id)
                        };

                        $q.all(promises)
                            .then(function (result) {
                                isVoluntaryStandbyListEnabled = result.isVoluntaryStandbyListEnabled;
                                self.showAnonymousEmployee = result.isAnonymisingEmployeesEnabled;

                                if (!user) {
                                    TSUsersService.loadUsers(brand.id, [$scope.teamUserId])
                                        .then(function () {
                                            user = TSUsersService.users[$scope.teamUserId];

                                            if (user) {
                                                drawIcons();
                                            }
                                        });
                                } else {
                                    drawIcons();
                                }
                            });
                    });
            };

            init();
        }
    };
}]);

app.directive('vedioWrapper', ['$timeout', function ($timeout) {
    return {
        templateUrl: '../scripts/global-directives/html/vedio_wrapper.html',
        restrict: 'A',
        scope: {
            'vedioId': '=',
            'name': '@',
            'extentions': '=',
        },
        'replace': true,
        link: function (scope, iElement, iAttrs) {

        }
    };
}]);

app.directive('preLoadOnHover', ['dependenciesLoaderService', function (dependenciesLoaderService) {
    return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
            $element.on("mouseover.lazy", function () {
                var stateToLoad = $attrs['uiSref'] || $attrs['preLoadOnHover'] || "";
                stateToLoad = stateToLoad.split("(")[0];
                var state = _.find(publicConfiguration['routes'], {name: stateToLoad});

                if (state && state['route_dependencies']) {
                    dependenciesLoaderService.load(state['route_dependencies']);
                }

                $element.off("mouseover.lazy");
            });
        }
    };
}]);

app.directive('hGoogleCalendarConnectBtn', [
    'harri.social.config', 'harri.social.Oauth2', '$modal',
    function (socialConfig, socialOAuth2, $modal) {
        return {
            templateUrl: "../scripts/global-directives/html/h_google_calendar_connect_btn.html",
            restrict: 'E',
            replace: true,
            scope: {
                'label': '@',
                'state': '@',
                'onSuccess': '&'
            },
            link: function (scope, iElement, iAttrs) {

                scope.connectCalendar = function () {

                    socialOAuth2().open(socialConfig.getProviders('calendar', scope.state)['google'])
                        .then(function (res) {
                            scope.onSuccess({response: res});
                        }, function (err) {
                            console.error("Error:", err);
                        });
                };
            }
        };
    }]);

app.directive('checkItem', [function () {
    return {
        templateUrl: "../scripts/global-directives/html/check_item.html",
        restrict: 'E',
        replace: true,
        scope: {
            'label': '=',
            'checked': '='
        },
        link: function (scope, iElement, iAttrs) {
        }
    };
}]);

app.directive('modalSection', [function () {
    return {
        templateUrl: "../scripts/global-directives/html/modal_section.html",
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {
            'label': '@'
        },
        link: function (scope, iElement, iAttrs) {
        }
    };
}]);


app.directive('modalItem', [function () {
    return {
        templateUrl: "../scripts/global-directives/html/modal_item.html",
        restrict: 'E',
        replace: true,
        scope: {
            'label': '=',
            'subtitle': '=',
            'description': '='
        },
        link: function (scope, iElement, iAttrs) {
        }
    };
}]);


/*
 // rel attr used for grouping elements
 <div class="sub-group accordion" accordion-toggle ng-repeat-start="skillsItem in skillsList" rel="accordion1">
 <div class="title open-sans light">
 title
 </div>
 <div class="fasep-5"></div>
 <div class="content">

 </div>
 </div>
 */
app.directive('accordionToggle', function () {
    return {
        scope: {
            rel: "@"
        },
        link: function (scope, element, attr) {

            if (scope.rel) {
                var $rel = $('.accordion[rel=' + scope.rel + ']');
            } else {
                console.log('please add rel ');
            }

            element.find('.title').on('click', function () {
                $('.accordion[rel=' + scope.rel + ']').toggleClass('open');
            });
        }
    };
});

app.directive('focusMe', ["$timeout", function ($timeout) {
    return {
        scope: {focus: '=focusMe'},
        restrict: 'A',
        link: function (scope, element) {
            scope.$watch('focus', function (value) {
                if (value === true) {
                    element[0].focus();
                    scope.trigger = false;
                }
            });
        }
    };

}]);

app.directive('stopFocusTrap', [() => {
    return {
        restrict: 'A',
        link: (scope, element) => {
            element.on('focusin.bs.modal', (e) => {
                e.stopPropagation();
                e.stopImmediatePropagation();
            })
        }
    };
}]);

/* Made by Laith
* Attrs:
* top-offset -> when the element comes sticky
* top -> set the top of the element under harri header
* sticky-element -> you can set the container of the element
* */
app.directive('stickyElement', [function () {
    return {
        restrict: "A",
        link: function (scope, element, attrs) {

            var selector = document;
            if (attrs.stickyElement) {
                selector = attrs.stickyElement;
            }

            setTimeout(function () {
                var elemTop = 0;
                elemTop = parseInt(element.offset().top);
                var elemWidth = element.outerWidth();

                var uniqueId = createUUID();
                var clonedElement = element.clone().attr('id', uniqueId).css('opacity', 0);

                var lastScrollTopPosition = 0;

                var updateStickyElement = function () {

                    var scrollTopValue = $(selector).scrollTop();

                    var startFixedHeight = scrollTopValue + parseInt(attrs.topOffset || 0);

                    // when user reaches in scroll to top that the element will be fixed on it
                    if (startFixedHeight > elemTop) {


                        if (!$('#' + uniqueId).length) {
                            clonedElement.insertAfter(element);
                        }

                        elemWidth = element.outerWidth();

                        var top = element.css('position') === 'fixed' ? parseInt(element.css('top')) : parseInt(attrs.top || 0);
                        var isElementViewedFromTop = startFixedHeight - 2 < element.offset().top;
                        var isElementViewedFromBtm = (element.offset().top + element.height()) < scrollTopValue + $(window).height();
                        var isScrollingTop = lastScrollTopPosition > scrollTopValue;

                        if (element.height() < $(window).height() - parseInt(attrs.top)) {
                            top = parseInt(attrs.top || 0);

                        } else if (isScrollingTop && !isElementViewedFromTop) {

                            if (!maxScrollFromTop || maxScrollFromTop <= 0) {
                                var maxScrollFromTop = element.offset().top - startFixedHeight;
                            }

                            var scrollBottomValue = $(selector).height() - (scrollTopValue + $(window).height());

                            var percent = scrollBottomValue / $(selector).height();
                            top += parseInt(Math.abs(maxScrollFromTop * percent));

                        } else if (!isScrollingTop && !isElementViewedFromBtm) {

                            top = parseInt(attrs.top || 0);

                            if (!maxScrollfromBtm || maxScrollfromBtm <= 0) {
                                var maxScrollfromBtm = element.height() + parseInt(attrs.top || 0) - $(window).height();
                            }
                            var percent = Math.ceil(scrollTopValue + parseInt(attrs.top)) / ($(selector).height() - $(window).height());
                            top -= parseInt(Math.abs(maxScrollfromBtm * percent));
                        }

                        if (element.css('position') !== 'fixed') {
                            element.css({
                                'position': 'fixed',
                                'width': elemWidth,
                                'z-index': 100
                            });
                        }

                        if (parseInt(element.css('top')) !== top) {
                            element.css({
                                'top': top,
                                'bottom': "",
                                'z-index': 2
                            });
                        }

                    } else if (startFixedHeight < elemTop && element.css('position') === 'fixed') {
                        $('#' + uniqueId).remove();
                        element.css({
                            'position': "",
                            'top': "",
                            'bottom': "",
                            'width': "",
                            'z-index': ""
                        });
                    }

                    lastScrollTopPosition = scrollTopValue;
                };

                element.on('heightChange', function () {
                    setTimeout(function () {
                        updateStickyElement();
                    }, 100);
                });

                $(selector).on('scroll.stickyElement', function (event) {
                    updateStickyElement();
                });
            }, 100);

            scope.$on("$destroy", function () {
                $(selector).off('scroll.stickyElement');
                element.off('heightChange');
            });
        }
    }
}]);


/**
 * [Truncate on how many lune number appear]
 * @param : {$compile,  $filter}
 * @attr  : { lineNumber : 'line-number (how many line to show)}
 * @directiveName :  { collapseLineNumber  : 'collapse-line-number' }
 */
app.directive('collapseLineNumber', ['$compile', '$filter', function ($compile, $filter) {
    return {
        restrict: 'A',
        scope: {
            'lineNumber': '@'
        },
        link: function (scope, element, attrs) {


            var lineHeight = parseInt(element.find('>div').css('line-height')),
                heightTruncate = scope.lineNumber * lineHeight,
                elementHeight = parseInt(element.find('>div').height());

            if (heightTruncate >= elementHeight) {
                return;
            }

            scope.showMore = false;

            element.height(heightTruncate);

            var showMoreButton = $compile('<span ng-show="!showMore" class="collapse-text-toggle" ng-click="showHide()" > <i class="fa fa-plus"></i> ' + $filter("translate")("More") + '</span> <span ng-show="showMore" class="collapse-text-toggle" ng-click="showHide()" > <i class="fa fa-minus"></i> ' + $filter("translate")("Less") + '</span>')(scope);
            element.parent().append(showMoreButton);

            scope.showHide = function () {
                scope.showMore = !scope.showMore;

                if (!scope.showMore) {
                    var elementTop = $(element).parent().offset().top - $('.top-header').outerHeight(true),
                        body = $('body');

                    if (elementTop >= body.scrollTop()) {
                        element.height(heightTruncate);
                    } else {
                        body.animate({scrollTop: elementTop}, 100, function () {
                            element.height(heightTruncate);
                        });
                    }
                } else {
                    element.height(elementHeight);
                }

            };
        }
    }
}]);

app.directive('collapseText', ['$compile', '$filter', function ($compile, $filter) {
    return {
        restrict: 'A',
        replace: true,
        scope: {
            collapseTextCallback: '&'
        },
        link: function (scope, element, attrs) {

            // start collapsed
            scope.collapsed = false;

            // create the function to toggle the collapse
            scope.toggle = function () {
                scope.collapsed = !scope.collapsed;
                scope.collapseTextCallback();
            };

            element.addClass('collapse-text');

            // get the value of the dd-collapse-text attribute
            attrs.$observe('collapseText', function (maxLength) {

                // get the contents of the element
                var text = element.text().trim();

                var bolded = "";

                if (attrs.bold !== undefined) {
                    bolded = "class='bold'";
                }

                if (text.length > maxLength) {
                    // split the text in two parts, the first always showing
                    var firstPart = String(text).substring(0, maxLength);

                    firstPart = firstPart.substr(0, Math.min(firstPart.length, firstPart.lastIndexOf(" ")));

                    var secondPart = String(text).substring(firstPart.length, text.length);


                    // create some new html elements to hold the separate info
                    var firstSpan = $compile(globalFilters['escapeDoubleCurlyBrackets'](' <span ' + bolded + '>' + firstPart.replace(/(?:\r\n|\r|\n)/g, '<br/>') + '</span> '))(scope);
                    var secondSpan = $compile(globalFilters['escapeDoubleCurlyBrackets'](' <span ng-show="collapsed" ' + bolded + '>' + secondPart.replace(/(?:\r\n|\r|\n)/g, '<br/>') + ' </span> '))(scope);
                    var moreIndicatorSpan = $compile('<span ng-show="!collapsed"> ... </span>')(scope);
                    var toggleButton = $compile('<button ng-show="!collapsed" class="collapse-text-toggle" ng-click="toggle()" > <i class="fa fa-plus"></i> ' + $filter("translate")("More") + '</button> <button ng-show="collapsed" class="collapse-text-toggle" ng-click="toggle()" > <i class="fa fa-minus"></i> ' + $filter("translate")("Less") + '</button>')(scope);
                    // toggleButton += $compile('')(scope);

                    // remove the current contents of the element
                    // and add the new ones we created
                    element.empty();
                    element.append(firstSpan);
                    element.append(secondSpan);
                    element.append(moreIndicatorSpan);
                    element.append(toggleButton);
                } else {
                    var contentSpan = $compile(' <span ' + bolded + '>' + text.replace(/(?:\r\n|\r|\n)/g, '<br/>') + '</span> ')(scope);
                    element.html(contentSpan);
                }
                scope.collapseTextCallback();
            });
        }
    };
}]);


app.directive('formatHtmlTags', ['$compile', function ($compile) {
    return {
        restrict: 'A',
        replace: true,
        scope: {},
        link: function (scope, element, attrs) {

            // get the contents of the element
            var text = element.text().trim();
            var secondSpan = String(text);
            secondSpan = $compile('<span>' + secondSpan + '</span>')(scope);
            element.empty();
            element.append(secondSpan);
        }
    };
}]);


/*============================================*/
/*== Colapse span directive (used in Job Post Landing Page)
/*============================================*/
app.directive('collapseSpans', ['$compile', '$filter', function ($compile, $filter) {
    return {
        restrict: 'A',
        replace: true,
        scope: {},
        link: function (scope, element, attrs) {
            // start collapsed
            scope.collapsed = false;
            // create the function to toggle the collapse
            scope.toggle = function () {
                scope.collapsed = !scope.collapsed;
            };
            // get the value of the dd-collapse-text attribute
            attrs.$observe('collapseSpans', function (spanNumbers) {
                // get the contents of the element
                var el_childern = element.find('>span');
                if (el_childern.length > spanNumbers) {
                    var newSpanArray = [];
                    for (var i = 0; i < el_childern.length; i++) {
                        var i_element = $(el_childern[i]);
                        var i_class = $(el_childern[i]).attr('class');
                        var i_text = $(el_childern[i]).text();

                        if (i < spanNumbers) {
                            newSpanArray.push($compile('<span class="' + i_class + '">' + i_text + '</span>')(scope));
                        } else {
                            newSpanArray.push($compile('<span ng-if="collapsed" class="' + i_class + '" >' + i_text + '</span>')(scope));
                        }
                        i++;
                    }
                    //console.log(newSpanArray);
                    element.empty();
                    element.append(newSpanArray);
                    $compile('<span ng-if="!collapsed"> ... </span>')(scope);
                    $compile('<span ng-if="!collapsed" class="collapse-text-toggle" ng-click="toggle()" > <i class="fa fa-plus"></i> ' + $filter("translate")("More") + '</span> <span ng-if="collapsed" class="collapse-text-toggle" ng-click="toggle()" > <i class="fa fa-minus"></i> ' + $filter("translate")("Less") + '</span>')(scope);
                }
            });
        }
    };
}]);
app.directive('tooltip', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            $(element)
                .attr('title', $filter('translate')(scope.$eval(attrs.tooltip)))
                .tooltip({html: true});

            //destroy tooltip when the element is removed
            scope.$on('$destroy', function () {
                $('.tooltip[role="tooltip"]').remove();
            });
        }
    }
});

app.directive('tooltipAngular', function () {
    return {
        restrict: 'A',
        scope: {
            'title': '@',
            'allowHtml': '@',
            'hideTooltip': '=',
            'tooltipContainer': '<',
            'customClass': '<',
        },
        link: function (scope, element, attrs) {
            var tooltipOptions = {
                html: !!scope.allowHtml,
                container: (scope.tooltipContainer || 'body'),
            };

            if (scope.customClass) {
                tooltipOptions.template = '<div class="tooltip ' + scope.customClass +
                    '" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';
            }

            $(element)
                .attr('title', scope.title)
                .tooltip(tooltipOptions);


            scope.$watch("hideTooltip", function (hideTooltip) {
                if (hideTooltip) {
                    $(element).tooltip("disable");
                } else {
                    $(element).tooltip("enable");
                }
            });

            //destroy tooltip when the element is removed
            scope.$on('$destroy', function () {
                $('.tooltip[role="tooltip"]').remove();
            });
        }
    }
});

/**
 * Close body menu
 * This written in inside factory because it is used inside other functions for some special cases such as hSelect.
 *
 * @param e
 * @constructor
 */
app.factory('HCloseBodyMenu', ['$timeout', function ($timeout) {

    function closeMenu(e, scope) {


        if ($('body').hasClass('open')) {
            $('body').addClass('has-no-overflow');
            $('body').toggleClass('open');

            if ($(window).width() <= 640) {
                $('body').addClass('closed-menu');
            }

            $timeout(function () {
                $('body').addClass('closed-menu');
                $('body').removeClass('has-no-overflow');
                scope.$apply();
            }, 500);

        }
        if ($('.map-holder').length > 0) {
            var smallOffset = 0;
            $timeout(function () {
                var smallOffset = 0;
                $('.map-holder > div').css({
                    '-webkit-transform': 'translateY(' + smallOffset + 'px)',
                    '-moz-transform': 'translateY(' + smallOffset + 'px)',
                    'transform': 'translateY(' + smallOffset + 'px)'
                });
            }, 200);
        }

        if ($('.navbar-fixed-top').length > 0) {
            var smallOffset = 0;
            var leftMenu = 0;
            $('.navbar-fixed-top').addClass('no-transition');
            $('.navbar-fixed-top').css({
                '-webkit-transform': 'translate(' + leftMenu + 'px,' + smallOffset + 'px)',
                '-moz-transform': 'translate(' + leftMenu + 'px,' + smallOffset + 'px)',
                'transform': 'translate(' + leftMenu + 'px,' + smallOffset + 'px)'
            });
            $('.navbar-fixed-top').removeClass('no-transition');
        }
    }

    return {
        'close': function (e, scope) {
            closeMenu(e, scope);
        },
        'isOpened': function () {
            return $('body').hasClass('open');
        }
    }
}]);


// Sticky: https://github.com/d-oliveros/angular-sticky/blob/master/sticky.js

window.matchMedia || (window.matchMedia = function () {
    window.console && console.warn && console.warn('angular-sticky: This browser does not support matchMedia, ' +
        'therefore the minWidth option will not work on this browser. ' +
        'Polyfill matchMedia to fix this issue.');
    return function () {
        return {
            matches: true
        };
    };
}());

// Sticky
app.directive('sticky', function () {
    var linkFn = function (scope, elem, attrs) {

        var mediaQuery = scope.mediaQuery || null,
            stickyClass = scope.stickyClass || '',
            bodyClass = scope.bodyClass || '',

            $elem = elem, elem = $elem[0],
            $window = angular.element(window),
            $body = angular.element(document.body),
            doc = document.documentElement,

            initial = {
                top: 'auto',
                width: $elem.css('width'),
                position: $elem.css('position'),
                marginTop: $elem.css('margin-top'),
            },

            isPositionFixed = false,
            isSticking = false,
            stickyLine;

        var offset = typeof scope.offset === 'string'
            ? parseInt(scope.offset.replace(/px;?/, ''))
            : 0;

        var anchor = typeof scope.anchor === 'string'
            ? scope.anchor.toLowerCase().trim()
            : 'top';
        switch (anchor) {
            case 'top':
            case 'bottom':
                break;
            default:
                console.log('Unknown anchor ' + anchor + ', defaulting to top');
                anchor = 'top';
                break;
        }

        // Watchers
        //
        var prevOffset = _getTopOffset(elem);

        scope.$watch(function () {
            if (isSticking) return prevOffset;

            prevOffset =
                (anchor == 'top')
                    ? _getTopOffset(elem)
                    : _getBottomOffset(elem);
            return prevOffset;

        }, function (newVal, oldVal) {
            if (newVal !== oldVal || typeof stickyLine === 'undefined') {
                stickyLine = newVal - offset;
                checkIfShouldStick();
            }
        });

        // checks if the window has passed the sticky line
        function checkIfShouldStick() {
            if (mediaQuery && !matchMedia('(' + mediaQuery + ')').matches) return;

            if (anchor == 'top') {
                var scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
                var shouldStick = scrollTop >= stickyLine;
            } else {
                var scrollBottom = (window.pageYOffset + window.innerHeight);
                if ($('header.top-header').length) {
                    scrollBottom = scrollBottom - 74;
                }

                var shouldStick = scrollBottom < stickyLine;
            }

            // Switch the sticky modes if the element has crossed the sticky line
            if (shouldStick && !isSticking)
                stickElement();

            else if (!shouldStick && isSticking)
                unstickElement();
        }

        function stickElement() {
            initial.offsetWidth = elem.offsetWidth;
            isSticking = true;
            bodyClass && $body.addClass(bodyClass);
            stickyClass && $elem.addClass(stickyClass);

            $elem
                .css('width', elem.offsetWidth + 'px')
                .css('position', 'fixed')
                .css(anchor, offset + 'px')
                .css('margin-top', 0);

            if (anchor == 'bottom') {
                $elem.css('margin-bottom', 0);
            }
        }

        function unstickElement() {
            isSticking = false;
            bodyClass && $body.removeClass(bodyClass);
            stickyClass && $elem.removeClass(stickyClass);

            $elem
                .css('width', initial.offsetWidth + 'px')
                .css('top', initial.top)
                .css('position', initial.position)
                .css('margin-top', initial.marginTop);
        }

        function _getTopOffset(element) {
            var pixels = 0;

            if (element.offsetParent) {
                do {
                    pixels += element.offsetTop;
                    element = element.offsetParent;
                } while (element);
            }

            return pixels;
        }

        function _getBottomOffset(element) {
            unstickElement();
            var bottomOffset = element.offsetTop + element.clientHeight;
            if ($(window).width() <= 768) {
                bottomOffset = element.offsetTop;
            }
            return bottomOffset;
        }

        scope.ctrlObject.updateStickyLine = function () {
            stickyLine = _getBottomOffset(elem) - offset;
            checkIfShouldStick();
        };

        // Listeners
        //
        $window.on('scroll', checkIfShouldStick);
        $window.on('resize', scope.$apply.bind(scope, onResize));
        scope.$on('$destroy', onDestroy);

        function onResize() {
            initial.offsetWidth = elem.offsetWidth;
        }

        function onDestroy() {
            $window.off('scroll', checkIfShouldStick);
            $window.off('resize', onResize);
        }
    };


    // Directive definition
    //
    return {
        scope: {
            anchor: '@',      // top or bottom
            offset: '@',      // offset from the top/bottom window edge
            mediaQuery: '@',  // minimum width required for sticky to come in
            stickyClass: '@', // class to be applied to the element on sticky
            bodyClass: '@',   // class to be applied to the body on sticky
            ctrlObject: '='   // object that passed from the controller
        },
        restrict: 'A',        // sticky can only be used as an ('A') attribute.
        link: linkFn
    };
});

// set dynamic name see: http://stackoverflow.com/questions/21455695/angularjs-dynamic-form-field-validation/21457121#21457121
app.directive("dynamicName", ["$compile", function ($compile) {
    return {
        restrict: "A",
        terminal: true,
        priority: 1000,
        link: function (scope, element, attrs) {
            element.attr('name', scope.$eval(attrs.dynamicName));
            element.removeAttr("dynamic-name");
            $compile(element)(scope);
        }
    };
}]);


// set dynamic name see: http://stackoverflow.com/questions/21455695/angularjs-dynamic-form-field-validation/21457121#21457121
app.directive("dynamicType", ["$compile", function ($compile) {
    return {
        restrict: "A",
        terminal: true,
        priority: 1000,
        link: function (scope, element, attrs) {
            element.attr('type', scope.$eval(attrs.dynamicName));
            element.removeAttr("dynamic-type");
            $compile(element)(scope);
        }
    };
}]);

app.directive("uploadProgress", ['$timeout', function ($timeout) {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "../scripts/global-directives/html/progress-bar.html",
        scope: {
            "title": "@",
            "errorMessage": "@",
            "status": "=",
            "progress": "="
        },
        link: function (scope, element, attrs) {

        }
    }
}]);


app.directive('harriScroll', ["$timeout", function ($timeout) {
    return {
        restrict: 'AE',
        scope: {
            // use `&` to store value as a function body
            // use `@` to store value as a string
            reachAction: '&harriScroll',
            noMoreAction: '=harriScrollDisabled',
            distance: '=harriScrollDistance'
        },
        link: function ($scope, $element, $attrs) {

            var checkScrollAvailability = function (element) {
                if (!!$scope.noMoreAction) {
                    return;
                }

                if ($(element).scrollTop() + $(element).innerHeight() >= $(element)[0].scrollHeight - 800) {
                    $scope.reachAction();
                }
            };


            /** $element.bind("DOMSubtreeModified",function(){
              console.log($($element).scrollTop(), $($element).innerHeight(), $($element)[0].scrollHeight);
              console.log($(this).find('div').first().height());
              console.log($(this).height());
              console.log("------------------------------------------------", $(this).find('div').first());
              if( $(this).height() >= $(this).find('div').first().height() ){
                if (!!$scope.noMoreAction) {
                  return;
                }
                // $scope.reachAction();
              }
            }); */

            $element.bind('scroll resize', function () {
                if ($(this).scrollTop() >= $(this)[0].scrollHeight - ($(this).innerHeight() * 3)) {

                    if (!!$scope.noMoreAction) {
                        return;
                    }
                    $scope.reachAction();
                }
            });


        }
    };

}]);


app.directive('globalHarriScroll', ["$timeout", function ($timeout) {
    return {
        restrict: 'AE',
        scope: {
            reachAction: '&globalHarriScroll',
            noMoreAction: '=harriScrollDisabled',
            distance: '=harriScrollDistance'
        },
        link: function ($scope, $element, $attrs) {

            $(window).scroll(function () {
                if ($(window).scrollTop() + $(window).height() >= ($(document).height() - $scope.distance)) {

                    if (!!$scope.noMoreAction) {
                        return;
                    }

                    $scope.reachAction();
                }
            });

        }
    };
}]);


/**
 * wordsCounterById
 * count input or textarea words this is a workaround angular bug:
 * This directive is work around for angular 1.2 bug https://github.com/angular/angular.js/issues/1412,
 * it should be solved in 1.3: the problem is angular does not update value until the model is valid.
 */
app.directive('wordsCounterById', ['$timeout', function ($timeout) {
    return {
        scope: {
            'wordsCounterById': '@',
        },
        link: function ($scope, $element, $attrs) {
            var $elem = $($scope.wordsCounterById);
            $timeout(function () {
                $elem.keyup(function () {
                    count();
                });
            });

            function count() {
                return $element.html($elem.val().split(' ').length);
            }
        }
    };
}]);

/**
 * charsCounterById
 * count input or textarea chars this is a workaround angular bug:
 * This directive is work around for angular 1.2 bug https://github.com/angular/angular.js/issues/1412,
 * it should be solved in 1.3: the problem is angular does not update value until the model is valid.
 */
app.directive('charsCounterById', ['$timeout', function ($timeout) {
    return {
        scope: {
            'charsCounterById': '@',
        },
        link: function ($scope, $element, $attrs) {
            var $elem = $($scope.charsCounterById);
            $timeout(function () {
                $elem.keyup(function () {
                    count();
                });
            });

            function count() {
                return $element.html($elem.val().length);
            }
        }
    };
}]);

/**
 * videoPlayer
 * Example
 *  <div id="video" video-player="card.video_answer">Loading the player...</div>
 *
 *  card.video_answer = {
       "path": "applications/17877/videos/d0ce83c845584992b7b2b66a40506fa2/",
       "type": "application_video",
       "uuid": "d0ce83c845584992b7b2b66a40506fa2",
       "video_domain": "http://d1etabe2rz2t7v.cloudfront.net/"
     }
 */
app.directive('hVideoPlayer', ['dependenciesLoaderService', function (dependenciesLoaderService) {
    return {
        scope: {
            hVideoPlayer: '='
        },
        link: function ($scope, $element, $attrs) {
            dependenciesLoaderService.load([{ type: "library", path: `${CDNUri || '../'}ext_libs/jwplayer/jwplayer.js` }])
                .then(function () {
                    $scope.hVideoPlayer.application_id = $attrs.applicationId;
                    if ($scope.hVideoPlayer.uuid) {
                        $scope.hVideoPlayer.media_uuid = $scope.hVideoPlayer.uuid;
                    }
                    hVideoPlayer($scope.hVideoPlayer, $attrs['id']);
                });
        }
    };
}]);


window.hVideoPlayer = (item, id) => {

    var width = $("#" + id).width() || 240;
    var height = $("#" + id).height() || 180;

    $("#" + id).width(width);
    $("#" + id).height(height);

    if (!jwplayer(id).setup) {
        console.log("jwPlayer is not defined");
        return;
    }

    var sources = [];

    if (item.transcoded_file) {
        var filePartsM3U8 = item.transcoded_file.split(".");
        sources.push({
            file: MediaUtils.hVideoLink([item.media_uuid, item.application_id, item.path, item.href], filePartsM3U8[0], filePartsM3U8[1]),
            label: "480P SD "
        });
    }

    if (item.media_uuid || item.href) {
        sources.push({
            file: MediaUtils.hVideoLink([item.media_uuid, item.application_id, item.path, item.href], '480P', 'mp4'),
            label: "480P SD "
        });
    }

    if (item.harriMedia) {
        sources.push({
            file: item.path,
            label: "480P SD "
        });
        jwplayer(id).setup({
            sources: sources,
            image: item.image,
            width: width,
            height: height,
            mute: item.mute || false,
            autostart: item.autostart || false
        });
    } else {
        jwplayer(id).setup({
            sources: sources,
            image: item.image || MediaUtils.hVideoLink([item.media_uuid, item.application_id, item.path, item.thumbnail_href], '480P-00001', 'png'),
            width: width,
            height: height,
            mute: item.mute || false,
            autostart: item.autostart || false
        });
    }
}


app.directive('basicInfoHandler', ['hFormReference', 'hUser', 'registrationApi', 'httpHelper', '$q', '$timeout', '$state', 'deviceChecker', function (hFormReference, hUser, registrationApi, httpHelper, $q, $timeout, $state, deviceChecker) {

    return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {

            /* disable brand logo restriction HARRI-5217*/
            var BRAND_LOGO_REQUIRED = false;

            var formName = 'application/basic_info';

            hFormReference.callbacks(formName, {
                beforeSave: function (formData) {
                    var referrer_username = hUser.getUserNameReferral();

                    if (referrer_username) {
                        formData.referrer_username = referrer_username;
                    }

                    return formData;
                },
                afterSave: function (data, formData, requestStatus) {

                    if (data.status_code != 200) {
                        return;
                    }

                    if (data.brand_id) {
                        //after brand saving
                        $scope.media_brand_id = data.brand_id;
                        $scope.media_brand_slug = data.brand_slug;

                        $scope.data.brands.email = data.data.email;
                        $scope.data.brands.slug = data.brand_slug;

                        $scope.data.brands.brand_id = data.brand_id;
                        $scope.data.brands.name = data.brand_name;


                        //take the user to the top of the page
                        $scope.flowBeforeActiveViewLoader().then(function () {
                            $timeout(function () {
                                try {
                                    if (deviceChecker.isMobile()) {
                                        $('body').animate({scrollTop: 0}, 0);
                                    } else {
                                        $('#emp-quick-reg-cont').animate({scrollTop: 0}, 0);
//                                        $('#emp-quick-reg-cont').scrollTo('.main-section:eq(0)', {duration:'slow', offsetTop : '100'});
                                    }

                                } catch (e) {
                                }
                            })
                        })


//                        scroll to top
//                        $('#emp-quick-reg-cont').scrollTo($("#quick_re_business_type"), {duration:'slow', offsetTop : '100'});
                    }

                }
            });

            //shared scope is to access forms scope
            var sharedFormsScope = {};
            hFormReference.callbacks('emp_quick_reg/brand', {
                beforeActive: function (data, formData, requestStatus) {

                    registrationApi.getHecsLookup()
                        .then(function (hecs) {
                            $scope.hecs = hecs;
                        })
                        .catch(function (err) {
                            console.error(err);
                        });

                    registrationApi.getCusineLookup()
                        .then(function (cusines) {
                            $scope.cusines = cusines;
                        })
                        .catch(function (err) {
                            console.error(err);
                        });

                }, afterSave: function (data, formData, requestStatus) {
                    function isUploadingStillInProgress() {
                        return sharedFormsScope.gallaryUploadingTotal > 0 || sharedFormsScope.iconloading > 0 || sharedFormsScope.coverloading > 0 || sharedFormsScope.headerloading > 0;
                    }

                    if (isUploadingStillInProgress()) {
                        var defer = $q.defer();

                        $scope.$watch(isUploadingStillInProgress, function (n) {
                            if (n === false) {
                                defer.resolve(data);
                            }
                        });

                        return defer.promise;
                    } else {
                        return data;
                    }


                }, beforeSave: function (formData, valid) {


                    if (BRAND_LOGO_REQUIRED && !(sharedFormsScope.brandBasicPhotos && sharedFormsScope.brandBasicPhotos.icon && sharedFormsScope.brandBasicPhotos.icon.uuid)) {
                        sharedFormsScope.brandMediaIconRequiredErrorFlag = true;
                        valid = false;
                    }

                    if (!valid) {

                        var modal = $('#emp-quick-reg-cont');
                        var firstError = modal.find(".has-error:eq(0)");

                        if (firstError.length > 0) {
                            if (deviceChecker.isMobile()) {

                                $('body').animate({
                                    scrollTop: firstError.offset().top
                                }, 1000);

                            } else {

                                modal.scrollTo(firstError, {duration: 'slow', offsetTop: '100'});

                            }
                        }

                        return false;
                    }

                    var defer = $q.defer();
                    var promises = {};

                    if (formData.cusine) {
                        formData.cusine = [formData.cusine];
                    }

                    if (formData.hecs) {
                        formData.hecs = [formData.hecs];
                    }

                    if ($.trim(formData.group_name) != "") {

                        promises.parent = httpHelper.put('user/brands', {
                            brand_name: formData.group_name
                        });

                        delete formData.group_name;

                    } else if (formData.group_name) {

                        delete formData.group_name;

                    }

                    $q.all(promises).then(function (res) {

                        if (res.parent && res.parent.data.data) {
                            formData.parent_id = res.parent.data.data.id;
                        }
                        defer.resolve(formData);

                    }, function (res) {

                        defer.reject(formData);

                    });

                    return defer.promise;

                }
            }).then(function (formObj) {
                sharedFormsScope = formObj.scope;

                sharedFormsScope.finishCreatingBrand = function () {
                    if (hUser.getLinkAfterLoginSuccessfully()) {
                        $timeout(function () {
                            hRedirect(join_query_link(hUser.getLinkAfterLoginSuccessfully(), {'ref': window.referer}));
                        });

                    } else {
                        window.location.reload(true);
                    }
                };
            });

            $scope.submit_reg_form = function () {

                hFormReference.getForm(formName).then(function (form) {
                    var scope = form.scope;
                    scope.lock_req = false;

                    // if not locked
                    if (!scope.lock_req) {

                        _.each(['first_name', 'last_name', 'password', 'email', 'phone'], function (name) {
                            scope.forms.app_registration[name].message = false;
                        });

                        scope.save(null, function (form) {
                            scope.lock_req = false;
                            hUser.init()
                                .then(function () {
                                    scope.$digest();
                                });

                            if (!form.valid) {
                                try {
                                    // set the validity of the email to true this allow the form to resubmit the form when user change the email
                                    scope.forms['app_registration'].email.$setValidity(true);
                                } catch (e) {
//                                        console.log(e);
                                }
                                console.log('Form invalid', form)
                            }

                            $scope.$broadcast('show-errors-reset');
                        }, undefined, scope.indexOf(formName), () => {
                            hRecaptchaUtil.execute(`submit`)
                        }, function () {
                            scope.lock_req = true;
                        });
                    }

                });
            };

            // Fix server side error messages
            $scope.$watch('data.app_registration.email', function (data) {
                if (data) {
                    $scope.forms.app_registration.email.message = null;
                }
            });

        }
    }

}]);


//employerQuickRegistration://basicInfo
app.factory('employerQuickRegistration', ["httpHelper", "$q", "googleMaps", "registrationApi", "$filter", "localize", function (httpHelper, $q, googleMaps, registrationApi, $filter, localize) {
    var APIs = {
        basicInfo: function (data) {

            var defer = $q.defer();

            var basic_info_data = removeAttrs(angular.copy(data), ['google_place']);

            //create a new user
            var basic_info = httpHelper.put(publicConfiguration.APIServerBaseURL.replace('v1', 'v2') + 'registration/basicInfo', basic_info_data);

            basic_info.then(function (r) {

                if (r.data.status_code == 200) {

                    if (localize.getLang() !== 'en') {
                        SettingsAPI.saveUserLocale(localize.getLang());
                    }

                    //employer quick registration
                    if (data.google_place) {
                        //create a brand
                        var brandPromise = APIs.createBrand(angular.copy(data));

                        //update user type
                        var userTypePromise = httpHelper.p('users/userType', {
                            "user_candidate": 0,
                            "user_employer": 1,
                            "user_network": 0
                        });

                        $q.all({brandPromise: brandPromise, userTypePromise: userTypePromise}).then(function (all) {

                            if (all.brandPromise.data.status_code == 200) {
                                //adding brand_id to returned data
                                r.data.brand_id = all.brandPromise.data.data.id;
                                r.data.brand_slug = all.brandPromise.data.data.slug;
                                r.data.brand_name = all.brandPromise.data.data.brand_name;


                                if (data.locationAutoComplete && data.locationAutoComplete.value) {

                                    registrationApi.addBrandLocations([data.locationAutoComplete.value], r.data.brand_id).then(function () {
                                        defer.resolve(r);
                                    }, function () {
                                        defer.resolve(r);
                                    })
                                } else {
                                    defer.resolve(r);
                                }

                            } else {
                                r.data.data = [{
                                    "error": $filter("translate")("The system can't save this brand, please use another one"),
                                    "field": "google_place"
                                }];
                                r.data.status_code = 403;
                                defer.resolve(r);
                            }

                        }, function () {
                            defer.reject(r);
                        })

                    } else {
                        //candidate quick registration
                        defer.resolve(r);
                    }


                } else {
                    defer.resolve(r);
                }

            }, function (r) {
                defer.reject(r);
            });


            return defer.promise;
        },

        createBrand: function (data) {

            data = keepAttrs(data, ['google_place', 'locationAutoComplete']);

            //custom name
            if (data.google_place.brand_name) {

                data.brand_name = data.google_place.brand_name;
                delete data.google_place;

                return httpHelper.put('user/brands', data);

            } else {
                //google place
                var defer = $q.defer();

                googleMaps.getDetails({placeId: data.google_place.place_id},
                    function (response) {

                        data.google_place = response;

                        httpHelper.put('user/brands', data).then(function (r) {
                            defer.resolve(r);
                        });

                    }
                );

                return defer.promise;
            }
        }

    };
    return APIs;
}]);

/**
 * This directive trigger form validation if it valid or not.
 *  - add check-form-validation="submit_reg_form()" to <form
 * usage example :
 *  - <form name="forms.app_registration" action="registration/basicInfo" method="PUT" form-data="app_registration" id="app-quick-reg-form" check-form-validation="submit_reg_form()"novalidate>
 */
app.directive('checkFormValidation', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, formElement, attrs) {

            var form_name = attrs.name.split('.')[1]; // get form name
            var form = scope.forms[form_name];

            var formValid = true, firstErrorField = null;
            formElement.bind('submit', function (e) {

                e.stopPropagation();
                e.preventDefault();

                _.each(form, function (field, name) {
                    //  all angular js function start with $ while forms input doesn't
                    if (typeof (name) == 'string' && !name.match('^[\$]') && typeof field === 'object') {
                        if (!field.$valid) {

                            field.$touched = true;
                            if (!firstErrorField) {
                                firstErrorField = field;
                            }
                        }
                    }
                });

                var invalid_elements = formElement.find('input.ng-invalid:first');
                if (invalid_elements.length > 0 && form.$invalid) {
                    // focus on the first invalid element
                    $timeout(function () {
                        scope.$apply(function () {
                            invalid_elements.first().focus();
                        });
                    })
                } else {
                    scope.$eval(attrs.checkFormValidation);
                }

            });


        }
    }
}]);


app.directive('logoutHref', ["$state", "hUser", function ($state, hUser) {
    return {
        link: function(scope, element) {
            element.click(function() {
                hLoginManager.signOut();
            });
        }
    }
}]);

app.directive('reload', ["$state", function ($state) {
    return {
        link: function (scope, element) {
            element.bind('click', function () {
                return hRedirect(hGetCurrentUrl());
            })
        }
    }
}]);


app.directive('formatDateFromNow', ["$filter", function ($filter) {
    return {
        scope: {
            formatDateFromNow: '='
        },
        link: function (scope, element) {
            var interval = 1000 * 30;
            var timeElement = element;
            var time = scope.formatDateFromNow;
            var timeago = $filter('formatDateFromNow')(time);
            timeElement.text(timeago);

            setInterval(function () {
                timeago = $filter('formatDateFromNow')(time);
                timeElement.text(timeago);
            }, interval)
        }
    }
}]);

app.directive('toggleSideBar', [function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {


            element.on('click', function () {
                $('.expandable-side-bar').toggleClass('open');
            });

            $(document).on('click touchstart', ".expandable-side-bar-area", function (e) {
                if ($('.expandable-side-bar').hasClass('open')) {
                    $('.expandable-side-bar').toggleClass('open');
                }
            });

            $(".toggle-sidebar").on('click touchstart', function (e) {
                e.stopPropagation();
            });

        }
    };
}]);

// http://stackoverflow.com/questions/24745167/angularjs-click-on-touchstart
app.directive("ngMobileClick", [function () {
    return function (scope, elem, attrs) {
        elem.bind("touchstart click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            scope.$apply(attrs["ngMobileClick"]);
        });
    }
}]);


/*=================================================*/
/*== Stop event progation
/*== http://stackoverflow.com/questions/14544741/how-can-i-make-an-angularjs-directive-to-stoppropagation/14547223#14547223
/*=================================================*/

app.directive('stopEvent', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            element.bind(attr.stopEvent, function (e) {
                e.stopPropagation();
            });
        }
    };
});


app.directive('languageSelector', ["hEvent", "localize", "$state", "$timeout", "httpHelper", "hUser", "deviceChecker", function (hEvent, localize, $state, $timeout, httpHelper, hUser, deviceChecker) {
    return {
        scope: {
            location: '@',
            source: '@',
        },
        templateUrl: '../scripts/global-directives/html/language-selector.html',
        link: function (scope, element, attrs) {

            scope.currentLang = localize.getLang();
            scope.defaultLang = localize.getLang();

            scope.loading = true;
            SettingsAPI
                .getPublicLocales()
                .then(function (languages) {

                    scope.languages = languages;
                })
                .finally(function () {
                    scope.loading = false;
                    scope.$digest();
                });

            if (scope.location === 'header') {
                element.find('.language-button').bind('click', function (event) {

                    element.find('ul.lang-dropdown').toggleClass('hidden');
                    element.find('ul.lang-dropdown').toggleClass('d-none');
                });
            }

            scope.changeLang = function (languageCode) {
                if (deviceChecker.isSafari()) {
                    hConfirm({
                        title: $filter("translate")("Confirmation"),
                        text: $filter("translate")("You are about to switch your preferred language, this will end your current session and will require you to login again."),
                        callback: function (confirmed) {
                            if (confirmed) {
                                scope.changeLanguage(languageCode);
                            }
                        }
                    })
                } else {
                    scope.changeLanguage(languageCode);
                }
            };

            scope.changeLanguage = function (languageCode) {

                var toLang = languageCode || scope.defaultLang;

                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                    key: 'lang',
                    value: toLang,
                    codec: false,
                    expiryDays: 30
                });

                hEvent.track(
                    "language_change",
                    {
                        "to": toLang,
                        "from": scope.currentLang,
                        'location': scope.location,
                        "page": $state.current.name,
                        'source': scope.source,
                    });

                $timeout(function () {
                    if (hUser.isLoggedIn()) {
                        SettingsAPI
                            .saveUserLocale(toLang)
                            .then(function () {
                                hRedirect(hGetCurrentUrl(toLang));
                            });
                    } else {
                        hRedirect(hGetCurrentUrl(toLang));
                    }
                });    
            };
        }
    }
}]);

app.factory('googleTranslation', ["$http", "$q", "localize", "httpHelper", function ($http, $q, localize, httpHelper) {

    var translationAPI = "https://www.googleapis.com/language/translate/v2";
    var key = publicConfiguration.keys.google.services;

    var translated = {};
    var detected = {};

    var googleTranslation = {

        translate: function (text, from, to) {

            var defer = $q.defer();

            if (translated[text]) {
                defer.resolve(translated[text]);
            } else {
                $http.get(translationAPI, {
                    params: {
                        key: key,
                        q: text,
                        target: to,
                        source: from
                    }
                }).then(function (res) {
                    var translation = res.data && res.data.data && res.data.data.translations && res.data.data.translations[0] && res.data.data.translations[0].translatedText;
                    translated[text] = translation;
                    defer.resolve(translation);
                });
            }

            return defer.promise;

        },
        detectLang: function (text, type, id) {

            var defer = $q.defer();

            if (publicConfiguration.isLanguageDetectionEnabled()) {

                text = Utils.getSubTextForLangDetection(text, type);

                if (detected[text]) {
                    defer.resolve(detected[text]);
                } else {
                    GoogleTranslationAPI.detectLanguage(text)
                        .then(function (detectedLanguage) {

                            if (type && id) {
                                httpHelper.p('translate_language', {
                                    "entity": type,
                                    "record_id": id,
                                    "language": detectedLanguage
                                })
                            }

                            defer.resolve(detectedLanguage);

                        })
                        .catch(function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                }
            } else {
                defer.reject({code: "DISABLED"});
            }

            return defer.promise;
        },
        prepareHtml: function (html) {
            var x = $("<div>");
            x.html(html);
            x.find("a").remove();
            return x.html();
        }
    };
    return googleTranslation;
}]);

app.directive('autoTranslate', ['localize', '$timeout', '$state', '$http', '$q', 'googleTranslation', '$filter', 'hEvent', 'TrackTextTranslate', function (localize, $timeout, $state, $http, $q, googleTranslation, $filter, hEvent, TrackTextTranslate) {
    return {
        strict: 'A',
        scope: {
            "type": '@',
            "language": '=',
            "id": '='
        },
        link: function (scope, element, attrs) {

            $timeout(function () {

                var text = element.text().trim();
                var originalElement = element.clone();
                var websiteLang = localize.getLang();

                var translateLabel = $filter("translate")("Translate");
                var showOriginalLabel = $filter("translate")("Show Original");

                //btns
                var translate = $("<span class='translate-btn'><br/><i class='fa fa-globe'></i> <span>" + translateLabel + "</span></span>").hide();
                var showOriginal = $("<span class='translate-btn'><br/><i class='fa fa-globe'></i> <span>" + showOriginalLabel + "</span></span>").hide();

                //container
                var translateContainer = $("<span class='translate-container'></span>");
                translateContainer.append(translate);
                translateContainer.append(showOriginal);

                //add container to message
                $(element).parent().append(translateContainer);

                if (scope.language) {
                    if (websiteLang !== scope.language) {
                        translate.show();
                        translate.bind('click', translateClickCallback);
                        showOriginal.bind('click', showOriginalClickCallback);
                    }
                } else {
                    var textDetectedLang;
                    googleTranslation.detectLang(text, scope.type, scope.id).then(function (detectedLang) {
                        textDetectedLang = detectedLang;
                        if (websiteLang !== detectedLang) {
                            translate.show();
                            translate.bind('click', translateClickCallback);
                            showOriginal.bind('click', showOriginalClickCallback);
                        }
                    })
                        .catch(function (err) {
                            if (err && ['DISABLED', 'UNDEFINED_LANG'].indexOf(err.code) > -1) {
                                return;
                            }

                            hLog("LANGUAGE", "AUTO_DETECT", err);
                        });

                }


                function translateClickCallback() {
                    googleTranslation.translate(text, textDetectedLang, websiteLang).then(function (translatedText) {

                        TrackTextTranslate.customEventsTrack(textDetectedLang, websiteLang);

                        hEvent.track('language_translate', {
                            'from': textDetectedLang,
                            'to': websiteLang,
                            'page': $state.current.name
                        }, function () {
                            translate.hide();
                            showOriginal.show();
                            $(element).html(translatedText);
                        });

                    });
                }

                function showOriginalClickCallback() {
                    translate.show();
                    showOriginal.hide();
                    $(element).html(originalElement.clone());
                }


            });
        }
    }
}]);

/**
 * Track some custom areas
 */
app.factory('TrackTextTranslate', ["$state", "hEvent", function ($state, hEvent) {

    var factoryObj = {};

    factoryObj.customEventsTrack = function (fromLang, toLang, extraData) {

        var eventName;
        var dataToSend = {
            'from': fromLang,
            'to': toLang
        };

        if (extraData && _.isObject(extraData)) {
            dataToSend = _.extend(dataToSend, extraData);
        }

        // Messaged Page
        if ($state.current.name.indexOf('appLayout.harriSH.messages') != -1) {
            eventName = 'translate_message';
        }
        // Job landing page
        else if ($state.current.name.indexOf('job-post') != -1) {
            eventName = 'translate_JPLP';
        }

        if (eventName) {
            hEvent.track(
                eventName,
                dataToSend,
                function () {
                }
            );
        }

    };


    return factoryObj;
}]);

app.directive('autoTranslateParts', ['localize', '$state', '$timeout', '$http', '$q', 'googleTranslation', '$filter', 'hEvent', 'TrackTextTranslate', function (localize, $state, $timeout, $http, $q, googleTranslation, $filter, hEvent, TrackTextTranslate) {
    return {
        strict: 'A',
        scope: {
            "type": '@',
            "language": '=',
            "id": '=',
            "extraData": '='
        },
        link: function (scope, element, attrs) {

            var websiteLang = localize.getLang();
            var textDetectedLang;
            var selectorsClasses = attrs.autoTranslateParts;
            var detectionClasses = attrs.autoDetectLangSelector || selectorsClasses;
            var translationCache = {};
            var showTranslated = true;
            var transRef = null;

            var translateLabel = $filter("translate")("Translate");
            var showOriginalLabel = $filter("translate")("Show Original");

            //btns
            var translateBtn = "<i class='fa fa-globe'></i> " + translateLabel;
            var showOriginalBtn = " <i class='fa fa-globe'></i> <span>" + showOriginalLabel;

            var lock = false;
            var promises = [];

            // this required in somes cases like SpeedyScreen
            var $parent = $(document);
            if (attrs.parent) {
                $parent = $(element).parents('.candidate-card-modal');
            }

            $timeout(function () {

                if (!publicConfiguration.isLanguageDetectionEnabled()) {
                    console.debug("Language Detection", "Disabled");
                    return;
                }

                if (scope.language && !attrs.detect) {
                    if (scope.language != websiteLang) {
                        element.show();
                    }
                } else {
                    $parent.find(detectionClasses).each(function () {

                        var textDetectedLang;
                        var textToTranslate = $(this).text().trim();

                        if (textToTranslate && textToTranslate.length > 4) {
                            googleTranslation.detectLang(textToTranslate, scope.type, scope.id)
                                .then(function (detectedLang) {
                                    textDetectedLang = detectedLang;
                                    if (websiteLang !== detectedLang) {
                                        element.show();
                                    }
                                }, function (err) {
                                    console.error("Failed to detect language, error:", err);
                                });
                        }
                    });
                }

                element.click(function () {
                    if (lock) {
                        return;
                    }
                    promises = [];
                    lock = true;
                    $parent.find(selectorsClasses).each(function () {
                        var $this = $(this);
                        var id = $this.attr('id');
                        if (!id) {
                            id = createUUID();
                            $this.attr('id', id);
                            translationCache[id] = {};
                        }

                        if (translationCache[id] && !translationCache[id].hasOwnProperty('original')) {
                            translationCache[id]['original'] = $this.html();
                            (function () {
                                var $ref = $this;
                                translationCache[id]['translated'] = $filter("translate")("Loading..");
                                transRef = googleTranslation.translate(translationCache[id]['original'], textDetectedLang, websiteLang).then(function (translatedText) {
                                    translationCache[id]['translated'] = translatedText;
                                    $ref.html(showTranslated ? translatedText : translationCache[id]['original']);
                                });
                            })();
                            promises.push(transRef);
                        } else if (translationCache[id]) {
                            $this.html(showTranslated ? translationCache[id]['translated'] : translationCache[id]['original']);
                            lock = false;
                        }
                    });


                    $q.all(promises).then(function () {
                        flipTranslationStatus(false);
                    }, function () {
                        flipTranslationStatus(false);
                    });
                });

            });

            function flipTranslationStatus(lockStatus) {
                lock = lockStatus;
                showTranslated = !showTranslated;
                if (showTranslated) {
                    element.html(translateBtn)
                } else {

                    TrackTextTranslate.customEventsTrack(textDetectedLang, websiteLang, scope.extraData);

                    hEvent.track(
                        'language_translate',
                        {
                            "from": textDetectedLang,
                            "to": websiteLang,
                            "page": $state.current.name
                        },
                        function () {
                            element.html(showOriginalBtn);
                        })
                }
            }
        }
    }
}]);

/**
 * Locations Formatter
 */
app.directive('jobLocationsFormatter', [function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {

            scope.buttons = {
                more: "",
                less: ""
            };

            $(element).find('.more-cities')
                .off('click')
                .on('click', function (e) {
                    $('.secondery-locations', $(element)).toggleClass('hidden');
                    $('.more-btn-text', $(element)).toggleClass('hidden');
                    $('.less-btn-text', $(element)).toggleClass('hidden');

                });
        }
    }
}]);


app.directive('nestedMenu', ["$timeout", "deviceChecker", function ($timeout, deviceChecker) {
    return {
        link: function (scope, element, attr) {


            $(element).off('click', '.nested-menu-view-label');
            $(element).on('click', '.nested-menu-view-label', function (e) {

                var $viewLabel = element.find('.nested-menu-view-label');
                var width = $viewLabel.outerWidth();
                var menuTopPos = $viewLabel.outerHeight();
                var $this = $(this).parent().find('.nested-menu-list-root');


                $this.css('width', (width + 2) + 'px');
                $this.css('top', (menuTopPos + 5) + 'px');
                if (deviceChecker.isMobile()) {
                    element.find('.nested-menu-view-label').css('width', $(window).width() + 'px !important');
                }


                var $lis = element.find('.nested-menu-list-root>li ');
                //open first element if its only one by default
                if ($lis.length == 1) {
                    var $firstElementli = element.find('.nested-menu-list-root>li');
                    if (!$this.hasClass('nested-menu-list-root-show')) {
                        $this.addClass('nested-menu-list-root-show');
                        $firstElementli.addClass('open-sub-menu');
                        $firstElementli.find('>a').addClass('open');
                        $firstElementli.find('>a>i').removeClass('fa-angle-down').addClass('fa-angle-up');
                        if (deviceChecker.isMobile()) {
                            $('.ams-handler').hide();
                        }

                    } else {
                        $this.removeClass('nested-menu-list-root-show');
                        $firstElementli.removeClass('open-sub-menu');
                        $firstElementli.find('>a').removeClass('open');
                        $firstElementli.find('>a>i').addClass('fa-angle-down').removeClass('fa-angle-up');
                        if (deviceChecker.isMobile()) {
                            $('.ams-handler').show();
                        }

                    }
                }
            });

            $(element).off('click', '.nested-menu-list li>a');
            $(element).on('click', '.nested-menu-list li>a', function (e) {


                if ($(this).hasClass('dont-collapse-the-list')) {
                    return;
                }

                if ($(this).parent().find('>ul').length > 0) {
                    e.preventDefault();
                }

                var $parent = $(this).parent();
                if ($parent.hasClass('open-sub-menu')) {
                    $parent.find('>a').removeClass('open');
                    $parent.find('>a>i').removeClass('fa-angle-up').addClass('fa-angle-down');
                } else {
                    $parent.find('>a').addClass('open');
                    $parent.find('>a>i').removeClass('fa-angle-down').addClass('fa-angle-up');
                }

                $parent.toggleClass('open-sub-menu');

                // hide siblings
                $parent.siblings().each(function () {
                    var $this = $(this);
                    $this.removeClass('open-sub-menu');
                    $this.find('>a').removeClass('open');
                    $this.find('>a>i').removeClass('fa-angle-up').addClass('fa-angle-down');
                });
            });

            // Close the menu
            $(document).off('.nestedmenu').on('mouseup.nestedmenu', function (e) {
                var container = element;
                if (!container.is(e.target) // if the target of the click isn't the container...
                    && container.has(e.target).length === 0) // ... nor a descendant of the container
                {
                    container.find(".nested-menu-list-root").removeClass('nested-menu-list-root-show');
                    container.find('.nested-menu-view-label').removeClass('open');
                    if (deviceChecker.isMobile()) {
                        $('.ams-handler').show();
                    }
                }
            });

        }
    }
}]);

/**
 * Mobile fixes for h-input enhance focusability on the mobile
 */
app.directive('hInputMobileFix', ["deviceChecker", function (deviceChecker) {
    return {
        link: function (scope, element, attr) {


            function hideKeyboard(element) {
                element.attr('readonly', 'readonly'); // Force keyboard to hide on input field.
                element.attr('disabled', 'true'); // Force keyboard to hide on textarea field.
                setTimeout(function () {
                    element.blur();  //actually close the keyboard
                    // Remove readonly attribute after keyboard is hidden.
                    element.removeAttr('readonly');
                    element.removeAttr('disabled');
                }, 100);
            }

            if (deviceChecker.isMobile()) {
                var moved = false;


                $(document).off('click', '.h-input-icon-1');
                $(document).on('click', '.h-input-icon-1', function (e) {
                    e.preventDefault();

                    var $this = $(this).find('input');
                    if ($this) {
                        $this.focus();
                    }

                });


                $(document).off('keydown', '.h-input-icon-1 input');
                $(document).on('keydown', '.h-input-icon-1 input', function (e) {
                    if (e.keyCode == 13) {
                        e.preventDefault();
                        $(':input:eq(' + ($(':input').index(this) + 1) + ')').focus();
                    }
                });

            }

        }
    }
}]);


/*
 * Login Flow Directive, a wrapper for login flow
 * holds the login flow (login form, reset password form, activated user)
 */
app.directive('hLoginFlow', ['hUser', '$rootScope', '$stateParams', function (hUser, $rootScope, $stateParams) {
    return {
        templateUrl: "../modules/forms/views/login_flow.html",
        restrict: 'E',
        replace: true,
        link: function ($scope, iElement, iAttrs) {

            $scope.isLoggedIn = hUser.isLoggedIn();

            $rootScope.$on('user_updated', function (event) {
                $scope.isLoggedIn = hUser.isLoggedIn();
                $scope.user = hUser.data.user;
            });

            $scope.isRadissonEmail = function (email) {
                return Utils.isEmailForCategory(email, 'RADISSON');
            };

            $scope.successCode = $stateParams.code;

            $scope.afterLogin = function (result, valid) {
                if (valid && result && result.response && result.response.data) {
                    hUser.loginSuccessfully(result.response.data);
                } else {
                    hAlert($filter("translate")("Error!"), $filter("translate")("something wrong happened, please try again!"));
                }
            };
        }
    };
}]);

app.directive('hLoginLayout', [function () {
    return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {

            $scope.loginOpened = false;

            $element.find(".modal#login-dialog").on("show.bs.modal", function () {
                if (!$scope.loginOpened) {
                    $scope.loginOpened = true;
                    $scope.$digest();
                }
            });

        }
    };
}]);


/* Discount Timer */
app.directive('discountTimer', ['$timeout', 'deviceChecker', 'hEvent', function ($timeout, deviceChecker, hEvent) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: '../scripts/global-directives/html/discount-timer.html',
        scope: {
            'time': '@',
            'counterStyle': '@?'
        },
        link: function ($scope, element, attrs) {

            $scope.targetTime = moment().add($scope.time, 'seconds');
            $scope.interval = 1000;
            $scope.seconds = 0;
            $scope.minutes = 0;
            $scope.hours = 0;

            $scope.start = function () {
                $scope.startTime = moment();
                resetTimeout();
                tick();
                $scope.isRunning = true;
            };

            var tick = function () {
                var diff = moment($scope.targetTime).diff(moment());
                $scope.millis = diff > 0 ? diff : 0;
                parseMillis();
                if ($scope.millis > 0) {
                    $scope.timeoutId = setTimeout(function () {
                        tick();
                        $scope.$digest();
                    }, $scope.interval);
                } else {
                    finishedCallBack();
                }
            };

            var parseMillis = function () {
                var seconds = Math.floor(($scope.millis / 1000) % 60);
                var minutes = Math.floor((($scope.millis / (60000)) % 60));
                var hours = Math.floor((($scope.millis / (3600000)) % 24));
                $scope.seconds = seconds >= 10 ? seconds : '0' + seconds;
                $scope.minutes = minutes >= 10 ? minutes : '0' + minutes;
                $scope.hours = hours >= 10 ? hours : '0' + hours;
            };

            var finishedCallBack = function () {
                console.log('finishedCallBack');
            };

            var resetTimeout = function () {
                if ($scope.timeoutId) {
                    clearTimeout($scope.timeoutId);
                }
            };

            $scope.start();
        }
    }
}]);


/* Eemployer join button used in places like ELP */
app.directive('trackButtonClick', ['$state', 'hEvent', function ($state, hEvent) {
    return {
        strict: 'A',
        scope: {
            "location": '@',
            "section": '@',
            "eventName": '@'
        },
        link: function (scope, element, attrs) {

            $(element).click(function () {
                hEvent.track(
                    scope.eventName + '_' + scope.location,
                    {
                        'location': scope.location,
                        'section': scope.section
                    });
            });
        }
    }
}]);


/* Directive attribute for toggle Drop down with custom element for drop-down menu */
app.directive('hDropdownMenu', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            var buttonRef = $(element).find('.h-dropdown-button');
            $(element).off('click');
            $(element).on('click', function (e) {
                if ($(element).hasClass('open')) {
                    $(element).removeClass('open');
                } else {
                    $(element).addClass('open');
                }
                scope.$digest();
            });
        }
    }
});

/* h drop down element for icons item or without icons */
app.directive('hDropdownMenu', ['deviceChecker', function (deviceChecker) {
    return {
        restrict: 'E',
        templateUrl: "../scripts/global-directives/html/h_dropdown_menu.html",
        scope: {
            items: "=",
            ngModel: "=",
            name: "@",
            id: "@",
            onChange: "&",
            container: "@",
            theme: "@",
            label: "@",
            icon: "@",
            disableDropDown: "=",
            disableIcon: "@",
            disableText: "@",
            onMenueElementSelected: "&",
            useDisplayLabel: "="
        },
        link: function (scope, element, attr) {
            scope.showNative = deviceChecker.isMobile();
            scope.ngModel = scope.ngModel || {value: ""};

            scope.selectOption = function (item) {
                if (scope.ngModel.id != item.id) {
                    scope.ngModel = item;
                    setTimeout(function () {
                        scope.onChange();
                    }, 1);
                }
                setTimeout(function () {
                    scope.onMenueElementSelected();
                }, 1);
            };
        }
    }
}]);


app.directive('hPasswordEye', ["$compile", function ($compile) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            'withIcon': '=',
            'icon': '@',
            'useSchemaValidate': '=',
            'globalName': '@',
            'id': '@',
            'name': '@',
            'autocomplete': '@',
            'hModel': '=',
            'placeholder': '@',
            'ngRequired': '@',
            'ngPattern': '@',
            'hPassword': '='
        },
        templateUrl: '../scripts/global-directives/html/password_fields.html',
        link: function (scope, $element, attrs) {

            scope.type = 'password';
            scope.eyeClass = 'fa-eye';

            /**
             * [change eye password in the input password field]
             */
            scope.hideShowPassword = function () {
                if (scope.type == 'password') {
                    scope.type = 'text';
                    scope.eyeClass = 'fa-eye-slash';
                } else {
                    scope.type = 'password';
                    scope.eyeClass = 'fa-eye';
                }
            };

        }
    };

}]);

app.directive('hValidatePassword', [function () {

    var link = function (scope, elm, attrs, ctrl) {

        if (!scope.hValidatePassword) {
            return;
        }

        ctrl.$validators.hValidatePassword = function (modelValue, viewValue) {

            if (ctrl.$isEmpty(modelValue)) {
                scope.hValidatePassword.passwordStrength.strength = '';
                scope.hValidatePassword.passwordStrength.label = '';
                scope.hValidatePassword.passwordStrength.hasUpperCase = false;
                scope.hValidatePassword.passwordStrength.hasLowerCase = false;
                scope.hValidatePassword.passwordStrength.hasSpecialChars = false;
                scope.hValidatePassword.passwordStrength.hasNumbers = false;
                return true;
            }

            var validatePassword = Utils.validatePassword(viewValue);

            scope.hValidatePassword.passwordStrength.strength = validatePassword.strength;
            scope.hValidatePassword.passwordStrength.label = validatePassword.label;
            scope.hValidatePassword.passwordStrength.hasUpperCase = validatePassword.hasUpperCase;
            scope.hValidatePassword.passwordStrength.hasLowerCase = validatePassword.hasLowerCase;
            scope.hValidatePassword.passwordStrength.hasSpecialChars = validatePassword.hasSpecialChars;
            scope.hValidatePassword.passwordStrength.hasNumbers = validatePassword.hasNumbers;

            if (scope.hValidatePassword.noValidation
                && scope.hValidatePassword.noValidation === true) {
                return true;
            }

            return validatePassword.pass;
        };

    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: link,
        scope: {
            'hValidatePassword': '='
        }
    }
}]);

app.directive('hPopover', ['$q', '$templateRequest', '$http', '$compile', 'localize', function ($q, $templateRequest, $http, $compile, localize) {

    var link = function (scope, elm, attrs) {

        var placement = localize.isRTL() ? 'right' : 'left';
        $templateRequest(attrs.hPopover).then(function (popoverContent) {

            if (deviceChecker.isMobile()) {
                elm.find("input").bind('focus change keydown click', function (e) {
                    scope.showInlinePasswordStrengthMessage = true;
                });
                elm.find("input").bind('blur ', function (e) {
                    scope.showInlinePasswordStrengthMessage = false;
                });
            } else {

                var options = {
                    content: $compile(popoverContent)(scope),
                    html: true,
                    placement: attrs.placement || placement,
                    container: attrs.container,
                    trigger: 'focus'
                };

                elm.popover(options);
            }

            scope.showStrengthPasswordModal = function () {

                if (deviceChecker.isMobile()) {
                    scope.showInlinePasswordStrengthMessage = true;
                } else {
                    elm.popover('show');
                }
            };

            if (attrs.openOnEvent) {
                elm.on(attrs.openOnEvent, function () {
                    elm.popover('show');
                });
            }

            $(document).on('hide.bs.modal', function () {
                elm.popover('hide');
            });

            $(document).click(function (e) {
                if ($(e.target).is('.close')) {
                    elm.popover('hide');
                }
            });
        });
    };

    return {
        restrict: 'A',
        link: link
    }

}]);

app.directive("hSimpleCalendar", ['$locale', function ($locale) {
    return {
        restrict: "E",
        templateUrl: '../scripts/global-directives/html/h_simple_calendar.html',
        scope: {
            selected: "=?",
            events: "=",
            startDate: "=",
            endDate: "=",
            id: '=',
            disabledEvents: '=?',
            disabled: '@',
            hChange: '&',
            hChangeMonthView: '&',
            eventsTriggersObject: '=',
            defaultDate: '=',
            monthsPerView: '@',
            mode: '@'
        },
        link: function (scope, $element, attrs) {

            var MODES = {
                SINGLE: 'SINGLE',
                RANGE: 'RANGE'
            };

            var isRangeMode = function () {
                return scope.mode && scope.mode === MODES.RANGE;
            };

            var isSingleMode = function () {
                return !scope.mode || (scope.mode && scope.mode === MODES.SINGLE);
            };


            var getNoOfMonths = function (date1, date2) {
                var noOfMonths;
                noOfMonths = (date2.year() - date1.year()) * 12;
                noOfMonths -= date1.month();
                noOfMonths += date2.month();
                return noOfMonths;
            };

            var highlightSelectedRange = function (from, to) {
                scope.months.forEach(function (month) {
                    month.weeks.forEach(function (week) {
                        week.days.forEach(function (day) {
                            day.startOfRange = day.date.isSame(from, 'day');
                            day.endOfRange = day.date.isSame(to, 'day');
                            day.inRange = day.date.isBetween(from, to) || day.startOfRange || day.endOfRange;
                        });
                    });
                });
            };

            /**
             * Draw the current month of the calender
             */
            scope.$watch('startDate', function (newV, oldV) {
                if (isRangeMode()) {
                    updateDisabledDays();
                }

                if (scope.id == "to_date" && isSingleMode()) {
                    var month = scope.month.clone();
                    _removeTime(month.month(month.month()).date(1));
                    _buildMonth(scope, month, scope.month);
                    if (!scope.day && typeof newV != 'string') {
                        var oldValueMoment;
                        if (!oldV) {
                            oldValueMoment = moment();
                        } else {
                            if (typeof oldV == 'string') {
                                if ((oldV[0] == '"' || oldV[0] == "'") && (oldV[oldV.length - 1] == '"' || oldV[oldV.length - 1] == "'")) {
                                    oldValueMoment = moment();
                                } else {
                                    oldValueMoment = moment(oldV);
                                }
                            } else {
                                if (moment.isMoment(oldV)) {
                                    oldValueMoment = oldV;
                                } else {
                                    oldValueMoment = moment(oldV);
                                }
                            }
                        }

                        var diff = getNoOfMonths(oldValueMoment, moment(newV || new Date()));
                        switchToMonth(diff);
                    }
                }
            });

            /**
             * Draw the current month of the calender
             */
            scope.$watch('endDate', function (newV, oldV) {

                if (isRangeMode()) {
                    updateDisabledDays();
                }

                if (scope.id == "from_date" && isSingleMode()) {
                    var month = scope.month.clone();
                    _removeTime(month.month(month.month()).date(1));
                    _buildMonth(scope, month, scope.month);
                }

            });

            var validateParameters = function () {

                if (isRangeMode()) {
                    if (scope.selected && scope.selected.date_from && !(scope.selected.date_from instanceof moment)) {
                        console.error('Calendar Error: When the calendar mode is range you should provide selected as object, may contain {date_from: Moment... } ');
                    }

                    if (scope.selected && scope.selected.date_to && !(scope.selected.date_to instanceof moment)) {
                        console.error('Calendar Error: When the calendar mode is range you should provide selected as object, may contain {date_to: Moment... } ');
                    }
                }

                if (isSingleMode() && scope.selected && !(scope.selected instanceof moment)) {
                    console.error('Calendar Error: When the calendar mode is single you should provide selected as Moment object');
                }
            };


            var start;
            var init = function () {
                validateParameters();
                if (isRangeMode()) {
                    if (scope.selected && (scope.selected.date_from || scope.selected.date_to)) {
                        scope.focusedRange = scope.selected;
                    } else {
                        scope.focusedRange = {date_from: moment(), date_to: moment()};
                    }
                    scope.focusedDate = scope.focusedRange.date_from || scope.focusedRange.date_to || moment();
                    scope.month = scope.focusedDate.clone();
                    var moveFocusedMonthPosition = 0;

                    if (!scope.selected.date_from) {
                        moveFocusedMonthPosition = (-1 * (scope.monthsPerView)) + 1;
                    }
                    scope.month.add(moveFocusedMonthPosition, 'months');
                    start = scope.month.clone();
                } else {
                    scope.focusedDate = scope.selected || moment();
                    scope.month = scope.focusedDate.clone();
                    start = scope.month.clone();
                }

                start.date(1);
                _removeTime(start.day(0));
                _buildView(scope, start.clone(), scope.month.clone());

                if (isRangeMode() && scope.selected && (scope.selected.date_from || scope.selected.date_to)) {
                    highlightSelectedRange(scope.selected.date_from || scope.selected.date_to, scope.selected.date_to || scope.selected.date_from);
                }

            };

            scope.days = moment.weekdays(true);
            //deafult minWidth
            scope.monthsPerView = scope.monthsPerView || 1;
            scope.monthsPerView = parseInt(scope.monthsPerView);
            scope.pickerMinWidth = scope.pickerMinWidth || 0;
            init();


            scope.select = function (day) {
                if (scope.disabled || !day.isSelectable) {
                    return;
                }
                isSingleMode() && selectSingleDay(day);
                isRangeMode() && selectRangeDay(day);
            };

            //select date
            var selectSingleDay = function (day) {

                // Always emit the selected date event if there is no events filter defined in scope
                var emitSelected = !scope.events || (day.events && day.events.length > 0);

                if (emitSelected || scope.disabledEvents) {
                    scope.selected = day.date;
                    scope.day = day;
                    scope.$emit('hSimpleCalendar.selectDay', day);
                }

                scope.hChange && scope.hChange({day: day.date});
            };

            var selectRangeDay = function (day) {
                if (!scope.selected || (scope.selected && scope.selected.date_from && scope.selected.date_to)) {
                    scope.selected = {
                        date_from: day.date
                    };
                } else {
                    if (scope.selected.date_from) {
                        scope.selected.date_to = day.date;
                    } else {
                        scope.selected.date_from = day.date;
                    }

                    if (scope.selected.date_from.isAfter(scope.selected.date_to)) {
                        var tmp = scope.selected.date_from.clone();
                        scope.selected.date_from = scope.selected.date_to.clone();
                        scope.selected.date_to = tmp;
                    }
                }

                scope.hChange && scope.hChange({range: scope.selected});
                highlightSelectedRange(scope.selected.date_from, scope.selected.date_to || scope.selected.date_from);
            };

            scope.onMouseover = function (day) {
                if (scope.disabled || !day.isSelectable) {
                    return;
                }
                if (isRangeMode() && scope.selected && scope.selected.date_from && !scope.selected.date_to) {
                    var from = scope.selected.date_from;
                    var to = day.date;
                    if (scope.selected.date_from.isAfter(day.date)) {
                        from = day.date;
                        to = scope.selected.date_from;
                    }
                    highlightSelectedRange(from, to);
                }
            };

            scope.isDaySelected = function (day) {
                if (isSingleMode()) {
                    return day.date.isSame(scope.selected, 'day');
                } else {
                    return (
                        day.isCurrentMonth &&
                        (scope.selected && scope.selected.date_from && day.date.isSame(scope.selected.date_from, 'day') ||
                            scope.selected && scope.selected.date_to && day.date.isSame(scope.selected.date_to, 'day'))
                    );
                }
            };
            //next nav
            scope.next = function (event) {
                switchToMonth(1 * scope.monthsPerView);
                scope.hChangeMonthView && scope.hChangeMonthView({
                    month: scope.month.clone().startOf('month'),
                    type: 'NEXT'
                });
                event.stopPropagation();
            };

            //pre nav
            scope.previous = function (event) {
                switchToMonth(-1 * scope.monthsPerView);
                scope.hChangeMonthView && scope.hChangeMonthView({
                    month: scope.month.clone().startOf('month'),
                    type: 'PREV'
                });
                event.stopPropagation();
            };

            var switchToMonth = function (monthShift) {
                var month = scope.month.clone();
                _removeTime(month.month(month.month() + monthShift).date(1));
                scope.month.month(scope.month.month() + monthShift);
                _buildView(scope, month.clone(), scope.month.clone());
                if (isRangeMode() && scope.selected && scope.selected.date_from) {
                    highlightSelectedRange(scope.selected.date_from, scope.selected.date_to || scope.selected.date_from);
                }

            };

            if (scope.eventsTriggersObject) {
                scope.eventsTriggersObject.render = function () {
                    init();
                }
            }

            var changeDefaultMonth = function () {
                if (!scope.defaultDate) {
                    return;
                }
                var currentMonthIndex = scope.month.month();
                var currentMonthYear = scope.month.year();
                var defaultDateMonthIndex = moment(scope.defaultDate).month();
                var defaultDateYear = moment(scope.defaultDate).year();

                if (currentMonthYear !== defaultDateYear) {
                    var yearDiff = defaultDateYear - currentMonthYear;
                    defaultDateMonthIndex += (yearDiff * 12);
                }

                if (defaultDateMonthIndex > currentMonthIndex || defaultDateMonthIndex < currentMonthIndex) {
                    var shiftMonth = defaultDateMonthIndex - currentMonthIndex;
                    shiftMonth = shiftMonth - scope.monthsPerView + 1;
                    switchToMonth(shiftMonth);
                }
            };

            changeDefaultMonth();

            scope.$watch('defaultDate', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    changeDefaultMonth();
                }
            });

            scope.monthSelectorOptions = [];
            var initMonthSelectorOptions = function () {
                scope.monthSelectorOptions = moment.months();
            };

            initMonthSelectorOptions();

            function updateDisabledDays() {
                scope.months.forEach(function (month) {
                    month.weeks.forEach(function (week) {
                        week.days.forEach(function (day) {
                            disableDayIfNotBetweenStartAndEnd(day, scope.startDate, scope.endDate);

                        });
                    });
                });
                switchToMonth(0);
            }

            var closeAllMonthsSelectors = function () {
                scope.months.forEach(function (month) {
                    month.monthSelectorVisible = false;
                });
            };

            scope.closeMonthSelector = function (event, month) {
                month.monthSelectorVisible = false;
                event.stopPropagation();
            };

            scope.openMonthSelector = function (event, month) {
                closeAllMonthsSelectors();
                month.monthSelectorVisible = true;
                event.stopPropagation();
            };

            scope.selectMonth = function (event, monthToSelectName, monthMomentToReplace) {
                var newMonth = monthMomentToReplace.clone().month(monthToSelectName);
                var shift = newMonth.month() - monthMomentToReplace.month();
                if (shift !== 0) {
                    switchToMonth(shift);
                }
                closeAllMonthsSelectors();
                event.stopPropagation();
            }
        }
    };


    //clear time from date and set to week start
    function _removeTime(date) {
        return date.day(0).hour(0).minute(0).second(0).millisecond(0);
    }


    function _buildView(scope, start, month) {
        scope.calenderStyle = {
            width: '280px'
        };
        scope.months = [];
        for (var i = 0; i < scope.monthsPerView; i++) {
            scope.months.push(_buildMonth(scope, start.clone(), month.clone()));
            month.add(1, 'months');
            start = month.clone().startOf('week');
        }

        if (scope.months.length > 1) {
            var percentage = 100 / scope.months.length;
            scope.calenderStyle = {
                width: percentage + '%'
            };
        }
    }

    //build month
    function _buildMonth(scope, start, month) {
        var weeks = [];
        var done = false;
        var date = month.clone().date(1).startOf('week');
        var monthIndex = date.month();
        var count = 0;
        while (!done) {
            weeks.push({
                days: _buildWeek(scope, date.clone(), month)
            });
            date.add(1, "w");
            done = count++ > 2 && monthIndex !== date.month();
            monthIndex = date.month();
        }

        return {
            weeks: weeks,
            month: month.clone()
        };
    }

    function disableDayIfNotBetweenStartAndEnd(day, startDate, endDate) {
        if (startDate) {
            if (!day.date.isAfter(startDate, "day") && !day.date.isSame(startDate, "day")) {
                day.isSelectable = false;
            }
        }

        if (endDate) {
            if (day.date.isAfter(endDate, "day")) {
                day.isSelectable = false;
            }
        }
    }

    function _buildWeek(scope, date, month) {
        var days = [];
        for (var i = 0; i < 7; i++) {

            var day = {
                name: date.format("dd").substring(0, 1),
                number: date.date(),
                isCurrentMonth: date.month() === month.month(),
                isToday: date.isSame(new Date(), "day"),
                date: date,
                status: [],
                isSelectable: true
            };

            if (scope.events && scope.events.length > 0) {
                var matchedEvents = findMatchedEvent(scope.events, date);
                if (matchedEvents.length > 0) {
                    day.events = matchedEvents;
                    for (var j in day.events) {
                        day[day.events[j].status] = true;
                        if (typeof (day.events[j].isSelectable) !== 'undefined') {
                            day.isSelectable = day.events[j].isSelectable;
                            day.uneditable = day.events[j].uneditable;
                        }
                    }
                }
            }

            disableDayIfNotBetweenStartAndEnd(day, scope.startDate, scope.endDate);


            days.push(day);
            date = date.clone();
            date.add(1, "d");
        }
        return days;
    }

    function findMatchedEvent(eventsArr, date) {
        var matchedEvents = [];

        for (var i in eventsArr) {
            // console.log(date,eventsArr[i].date);
            if (date.isSame(eventsArr[i].date, 'day')) {
                matchedEvents.push(eventsArr[i]);
            }
        }

        return matchedEvents;
    }
}]);

//preview document directive
//this directive is responsible for documents preview while inserting or updating data
app.directive("documentGenerator", ["$sce", function ($sce) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            getDocData: '=',
            docCode: '@',
            templateCode: '@',
            downloadDoc: '=',
            docId: '@',
            page: '@'
        },
        templateUrl: function (elem, attrs) {
            if (attrs.templateName) {
                switch (attrs.templateName) {
                    case 'anchor':
                        return '../scripts/global-directives/html/document-generator/anchor.html'
                    case 'anchor-icon':
                        return '../scripts/global-directives/html/document-generator/anchor-icon.html'
                    case 'download-doc':
                        return '../scripts/global-directives/html/document-generator/download-doc.html'
                    default:
                        return '../scripts/global-directives/html/document-generator/' + attrs.templateName + '.html'
                }
                
            } else {
                return '../scripts/global-directives/html/document-generator/preview-doc.html';
            }
        },
        link: function (scope, $element, attrs) {

            scope.text = attrs.text || $filter("translate")("Preview");

            //generate the form URL
            var formAction = publicConfiguration.OnboardingServerBaseURL + 'document_preview/' + scope.docCode;
            //angular will block the form url if it was not trusted
            // formAction = $sce.trustAsResourceUrl(formAction);
            var requestBody = {};

            if (scope.downloadDoc) {
                requestBody['force_download'] = true;
            }

            requestBody['doc_code'] = scope.docCode;
            requestBody['return_url'] = true;
            // this when we have another level of template=
            if (scope.templateCode) {
                requestBody['template_code'] = scope.templateCode;
            }

            //submit the form
            scope.generateDocument = function () {
                //excute before preview
                if (scope.getDocData) {
                    //construct meta value
                    var value = scope.getDocData(scope.docCode, scope.docId);
                    requestBody['meta_data'] = value;
                    var newWindow = window.open('about:blank');
                    var spinner = '<div style="color: black; font-size: 23px; text-align: center; width: 100%; padding-top: 200px;">Loading...</div>';
                    $(newWindow.document).find('body').append(spinner);
                    if (scope.docCode === OnBoardingAPI.DOCUMENT_TYPE.STATE_W_DISPATCHER && scope.templateCode) {
                        requestBody['template_code'] = scope.templateCode;
                    }
                    var link = OnBoardingAPI.documentPreview(scope.docCode, requestBody).then(function (link) {
                        if (scope.page) {
                            link += "#page=" + scope.page;
                        }
                        newWindow.location = link;
                        newWindow.focus();
                    });
                } else {
                    console.error('No Data to preview');

                }
            };
        }
    }
}]);

app.directive("pdfViewer", ["$sce", "deviceChecker", function ($sce, deviceChecker) {
    return {
        restrict: "E",
        templateUrl: '../scripts/global-directives/html/pdf-viewer.ng.html',
        transclude: true,
        scope: {
            url: '='
        },
        link: function (scope, $element, attrs) {

            scope.documentUrl = angular.copy(scope.url);
            scope.documentUrl = $sce.trustAsResourceUrl(scope.documentUrl);

            if (deviceChecker.isMobile()) {
                scope.showDownload = true;
            }
        }
    }
}]);


app.directive("cutName", ["$compile", function ($compile) {
    return {
        restrict: "A",
        scope: {
            onMoreClick: '&?'
        },
        link: function (scope, element, attrs) {

            setTimeout(function () {
                var dotKey = '...';
                while ($(element).find('span').height() > attrs.textHeight) {
                    var text = $(element).find('span').text();
                    text = text.split(' ');
                    if (text[text.length - 1] === dotKey) {
                        ar_delete(text, text.length - 2);
                    } else {
                        ar_delete(text, text.length - 1);
                        text.push(dotKey);
                    }

                    var appendedText = angular.copy(text);
                    ar_delete(appendedText, text.length - 1);
                    $(element).find('span').html(appendedText.join(' '));
                    if (scope.onMoreClick) {
                        $(element).find('span').append($compile("<span class='pointer' ng-click='onMoreClick()()'>...</span>")(scope));
                    } else {
                        $(element).find('span').append('<span>...</span>');
                    }
                }
            }, 200);

        }
    }
}]);

app.directive("tickDropdown", ['deviceChecker', function (deviceChecker) {
    return {
        restrict: "E",
        templateUrl: '../scripts/global-directives/html/tick_dropdown.html',
        scope: {
            specialDropIcon: "@",
            icon: "@",
            id: "@",
            ngModel: "=",
            items: "=",
            specialTickIcon: "@",
            label: "@",
            onChange: "&",
            name: "@"
        },
        link: function (scope, element, attrs) {

            scope.showNative = deviceChecker.isMobile();

            scope.selectOption = function (item) {

                if (scope.ngModel.value != item.value) {

                    scope.ngModel = item;

                    setTimeout(function () {
                        scope.onChange();
                    }, 1);
                }
            };
        }
    }
}]);

app.directive("hScrollTo", [function () {
    return {
        restrict: "A",
        scope: {},
        link: function (scope, element, attrs) {

            var targetSelector = attrs.hScrollTo;

            element.click(function () {
                $("body, html").scrollTo(($(targetSelector).offset().top - $('body').offset().top) - 120);
            })
        }
    }
}]);


app.directive('profilePicUpload', ["$q", "asyncGlobalHandler", "Upload", "$timeout", "hFormReference", "$rootScope", "resume", "hUser", "hEvent", function ($q, asyncGlobalHandler, Upload, $timeout, hFormReference, $rootScope, resume, hUser, hEvent) {
    return {
        link: function ($scope, element, attr) {

            // @TODO refactor in function in the public config
            var profilePicAction = attr.profilePicAction;
            $scope.userId = attr.userId;
            if (profilePicAction.indexOf("http") == -1) {
                profilePicAction = publicConfiguration.APIServerBaseURL + profilePicAction;
            }

            $scope.profile_pic_progess = 0;

            // NTHN | IN_PROGRESS | DONE | ERROR
            // NTHN : yet doesn't started
            // IN_PROGRESS : uploading right now
            // DONE : Finished
            // ERROR : error
            $scope.profile_pic_progress_status = 'NTHN';

            function readImageFromFile($files) {
                // Reading image is blocks other operations (takes long time for large images)
                // Delay it for some time
                $timeout(function () {
                    $scope.loadImageWithFileReader($files).then(function (images) {
                        if (images[0]) {
                            $('#photo-preview').addClass('hide-user-upload-icon')
                                .css('background-image', 'url(' + images[0] + ')');
                        }
                    });
                }, 1000);
            }

            $scope.onProfilePicSelect = function ($files) {

                if (!$files || !$files[0]) {
                    return;
                }

                if ($files.length) {
                    $rootScope.$broadcast('showImageCroppingModalLoading');
                }

                $scope.uploadStatus(false);

                // readImageFromFile($files);

                // send selected files && show modal
                $rootScope.$broadcast('showImageCroppingModal', {
                    file: $files[0],
                    croppingModalCallBack: function (coords, image, cropref) {

                        $('#photo-preview').addClass('hide-user-upload-icon');

                        // Change Blob to look like a file
                        image.name = $files[0].name;
                        image.lastModifiedDate = $files[0].lastModifiedDate;
                        $scope.profile_pic_progress_status = 'IN_PROGRESS';
                        if (hUser.isLoggedIn()) {
                            HStorageManager.remove({
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                key: 'placeholder_token'
                            });
                        }
                        const placeholderToken = HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'placeholder_token'
                        });
                        if (attr.profilePicTrackingCategory === 'job_apply' && placeholderToken) {
                            coords.placeholder_token = placeholderToken;
                        }

                        $scope.upload = Upload.upload({
                            url: profilePicAction,
                            withCredentials: true,
                            headers: {},
                            method: 'PUT',
                            data: coords,
                            file: image
                        }).progress(function (evt) {

                            $scope.profile_pic_progress = parseInt(100.0 * evt.loaded / evt.total);

                        }).success(function (data, status, headers, config) {

                            $scope.uploadStatus(true);
                            // file is uploaded successfully
                            if (data.status_code == 200) {
                                $scope.profile_pic_progress_status = 'DONE';
                                $scope.profile_pic_uuid = data.data;
                                if (attr.profilePicTrackingCategory === 'job_apply') {
                                    $scope.profile_pic_url = MediaUtils.hUserProfileImage([$scope.profile_pic_uuid, $scope.userId], '_icon_user_search', true);
                                } else {
                                    $scope.profile_pic_url = MediaUtils.hUserProfileImage([$scope.profile_pic_uuid, hUser.data.user.id], '_icon_user_search', true);
                                }
                                //set profile pic for resume to be aware that a profile pic was uploaded
                                resume.setProfilePicUUID(data.data);

                                if (attr.profilePicTracking) {
                                    hEvent.track('profile_photo_upload', {'category': attr.profilePicTrackingCategory});
                                }
                            } else {
                                $scope.profile_pic_progress_status = 'ERROR';
                            }

                        }).error(function (reason) {
                            $scope.uploadStatus(false);
                            $scope.profile_pic_progress_status = 'ERROR';
                        });

                    }
                });

            };

            $scope.uploadStatus = function (status) {
                hFormReference.getForm('application/photo_apply').then(function (form) {
                    var scope = form.scope;
                    scope.photoUploaded = status;
                    //show photouploaded flag
                    scope.$parent.data.photoUploaded = status;
                });
            };

            $scope.apply_reset_upload = function () {
                $scope.uploadStatus(false);
                $timeout(function () {
                    $scope.profile_pic_progress_status = 'NTHN';
                });
            };
        }
    }
}]);


app.directive('replaceBrokenImg', [function () {
    return {
        link: function ($scope, element, attr) {
            $(element).error(function () {

                $(this).replaceWith('<div class="img-thumbnail empty-thumbnail"><i class="fa fa-file-video-o"></i> </div>').unbind('error');
            });
        }
    }
}]);

// TODO: Check if needed
// Used in  EmpQuickReg + PreInterview
app.directive('loadFormsData', ['hFormReference', 'hUser', '$timeout', function (hFormReference, hUser, $timeout) {
    return {
        link: function postLink(scope, element, attrs) {
            $timeout(function () {
                if (hUser.isLoggedIn()) {
                    scope.flowBeforeActiveViewLoader();
                }
            });

        }
    }
}]);

app.directive('patternRestrict', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (!attr.patternRestrict) {
                return;
            }

            var pattern = new RegExp(attr.patternRestrict);
            $(element).off('keyup');

            $(element).keyup(function (e) {
                var input = $(element).val();
                var match = input.match(pattern);
                var matched = match != null && input == match[0];

                if (!matched) {
                    match = match || [];
                    if (input.indexOf(e.key) != -1) {
                        $(element).val(match[0]);
                    }
                }

                scope.$digest();
            });

            scope.$on('$destroy', function () {
                $(element).off('keyup');
            });
        }
    }
});

app.directive('formatNumber', function () {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            ctrl.$parsers.unshift(parseNumber);
            ctrl.$formatters.unshift(formatNumber);

            function formatNumber(viewValue) {
                var nStr = viewValue;
                nStr += '';
                var x = nStr.split('.');
                var x1 = x[0];
                var x2 = x[1];
                var x2 = x.length > 1 ? '.' + x[1] : '';
                var rgx = /(\d+)(\d{3})/;
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + ',' + '$2');
                }
                return x1 + x2;
            }

            function parseNumber(viewValue) {
                var nStr = viewValue.replace(/,/g, '');
                nStr = nStr.replace(/[^0-9,.]/g, '');
                nStr += '';
                var x = nStr.split('.');
                var x1 = x[0];
                var x2 = x.length > 1 ? '.' + x[1] : '';
                var rgx = /(\d+)(\d{3})/;
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + ',' + '$2');
                }
                //update view with formated value
                elem[0].value = x1 + x2;

                //update model with clean number
                return (x1 + x2).replace(/,/g, '');
            }
        }
    }
});

app.directive('twoDecimalPlaces', function () {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            ctrl.$formatters.unshift(formatNumber);

            function formatNumber(viewValue) {
                var nStr = viewValue;
                nStr += '';
                var x = nStr.split('.');
                var x1 = x[0];
                var x2 = x[1];
                if (x2) {
                    if (x2.length == 1) {
                        x2 = "0";
                    } else if (x2.length > 1) {
                        x2 = "";
                    }
                } else {
                    x2 = ".00";
                }

                return x1 + x2;
            }

            elem.on('blur', forceTwoDecimalPlaces);

            function forceTwoDecimalPlaces() {
                var fraction = elem[0].value.split('.');
                fraction = fraction [1];
                if (fraction) {

                    if (fraction.length == 1) {
                        fraction = "0";
                    } else if (fraction.length > 1) {
                        fraction = "";
                    }
                } else {
                    if (elem[0].value.includes('.')) {
                        fraction = "00";
                    } else if (elem[0].value !== '') {
                        fraction = ".00";
                    }

                }
                elem[0].value = elem[0].value + fraction;
            }
        }
    }
});

app.directive('toDecimalPlaces', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            'toDecimalPlaces': '@',
        },
        link: function (scope, elem, attrs, ctrl) {
            ctrl.$formatters.unshift(formatDecimals);
            var decimal = parseInt(scope.toDecimalPlaces) || 2;

            function formatDecimals(viewValue) {
                var formatted_value = parseFloat(viewValue).toFixed(decimal);

                return formatted_value;
            }

            elem.on('blur', toFixedDecimalPlaces);

            function toFixedDecimalPlaces() {
                if (elem[0].value) {
                    elem[0].value = parseFloat(elem[0].value).toFixed(decimal);
                }
            }
        }
    }
});

app.directive('modalAnimateShake', function () {
    return {
        strict: 'A',
        link: function (scope, elm, attrs) {
            if (attrs.modalAnimateShake && attrs.modalAnimateShake === 'false') return;

            elm.find('.modal-dialog').addClass('animated');
            elm.on('click', function (e) {
                if (e.target.className.indexOf('h-modal') > -1) {
                    elm.find('.modal-dialog').addClass('shake');

                    setTimeout(function () {
                        elm.find('.modal-dialog').removeClass('shake');
                    }, 1000);
                }
            });
        }
    }
});

app.directive('infoTooltip', function () {

    return {
        templateUrl: '../scripts/global-directives/html/info-tooltip.html',
        restrict: 'E',
        replace: false,
        scope: {
            text: '@',
            color: '@?',
            trigger: '@?',
            icon: '@?',
            container: '@?',
            placement: '@?',
            viewport: '@?'
        },
        compile: function (element, attrs) {
            attrs.color = attrs.color || 'gray';
            attrs.trigger = attrs.trigger || 'hover';
            attrs.icon = attrs.icon || 'fa-info-circle';
            attrs.container = attrs.container || 'body';
            attrs.placement = attrs.placement || 'top';
            attrs.viewport = attrs.viewport || 'body';
        },
        link: function (scope, elm, attrs) {
        }
    };
});


app.directive('redirectToWorkspace', ['$state', function ($state) {
    return {
        restrict: 'A',
        replace: false,
        bindToController: {
            redirectToWorkspace: '@',
            isUrl: '@',
            target: '@'
        },
        controller: ['$element', '$attrs', '$scope', function ($element, $attrs, $scope) {
            const ctrl = this;
            let params = {};

            function updateHref(url, ref) {
                const href = url || $state.href(ref.state, params, { absolute: true });
                $attrs.$set('href', href);
                $attrs.$set('target', ctrl.target || '_self');
            }

            function parseStateRef(ref) {
                const paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
                if (paramsOnly) ref = '(' + paramsOnly[1] + ')';

                const parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
                if (!parsed || parsed.length !== 4) {
                    throw new Error("Invalid state ref '" + ref + "'");
                }
                return { state: parsed[1] || null, paramExpr: parsed[3] || null };
            }

            function initializeLink() {
                if (!ctrl.redirectToWorkspace) {
                    return;
                }

                if (ctrl.isUrl === 'true') {
                    updateHref(ctrl.redirectToWorkspace);
                } else {
                    const ref = parseStateRef(ctrl.redirectToWorkspace);
                    
                    if (ref.paramExpr) {
                        $scope.$watch(
                            function() {
                                return $scope.$parent.$eval(ref.paramExpr);
                            },
                            function(newVal) {
                                if (newVal !== undefined) {
                                    params = Object.assign({}, newVal);
                                    updateHref(undefined, ref);
                                }
                            },
                            true
                        );

                        const initialParams = $scope.$parent.$eval(ref.paramExpr);
                        if (initialParams) {
                            params = Object.assign({}, initialParams);
                        }
                    }
                    
                    updateHref(undefined, ref);
                }
            }

            this.$onInit = function() {
                initializeLink();
            };
        }],
        controllerAs: 'redirectCtrl'
    };
}]);
